import React from "react";
import { Modal } from "react-bootstrap";
import { Header } from "Views/Private/Admin/ApplicationStatus/Header";
import { Chat } from "Views/Private/Admin/ApplicationStatus/Chat";

export const GlobalChat = ({ show, toggle, taskId }) => {
  return (
    <Modal
      show={show}
      onHide={toggle}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="chat-modal"
    >
      <Modal.Header closeButton className="chat-header" />
      <Modal.Body className="comment-modal">
        <Header gid={taskId} />
        <Chat gid={taskId} />
      </Modal.Body>
    </Modal>
  );
};
